import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { axiosBuzzNotification, axiosBuzzOne } from '../../axios';
const moduleName = 'buzz';

export const getAllBuzzSubscriptionProducts = createAsyncThunk(
  `GET/${moduleName}/subscriptions/products`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosBuzzOne({
        method: 'GET',
        url: '/buzz/subscriptions/products',
        params: payload,
      });
      const data = response.data;
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getAllBuzzSubscriptionPlans = createAsyncThunk(
  `GET/${moduleName}/subscriptions/plans`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosBuzzOne({
        method: 'GET',
        url: '/buzz/subscriptions/plans',
        params: payload,
      });
      const data = response.data;
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getBuzzSubscriptionPlanOptions = createAsyncThunk(
  `GET/${moduleName}/subscriptions/plans/options`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosBuzzOne({
        method: 'GET',
        url: '/buzz/subscriptions/plans/options',
      });
      const data = response.data;
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getBuzzPlanLicenseTypes = createAsyncThunk(
  `GET/${moduleName}/subscriptions/plans/license-types`,
  async ({ planId }, { rejectWithValue }) => {
    try {
      const response = await axiosBuzzOne({
        method: 'GET',
        url: `/buzz/subscriptions/plans/${planId}/license-types`,
      });
      const data = response.data;
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getBuzzPlanClasses = createAsyncThunk(
  `GET/${moduleName}/subscriptions/plans/classes`,
  async ({ planId }, { rejectWithValue }) => {
    try {
      const response = await axiosBuzzOne({
        method: 'GET',
        url: `/buzz/subscriptions/plans/${planId}/classes`,
      });
      const data = response.data;
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const addNewBuzzSubscriptionPlan = createAsyncThunk(
  `POST/${moduleName}/subscriptions/plans`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosBuzzOne({
        method: 'POST',
        url: '/buzz/subscriptions/plans',
        data: payload,
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateBuzzSubscriptionPlan = createAsyncThunk(
  `PUT/${moduleName}/subscriptions/plans`,
  async (payload, { rejectWithValue }) => {
    const { id, data } = payload;
    try {
      const response = await axiosBuzzOne({
        method: 'PUT',
        url: `/buzz/subscriptions/plans/${id}`,
        data: data,
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getAllBuzzSubscriptions = createAsyncThunk(
  `GET/${moduleName}/subscriptions`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosBuzzOne({
        method: 'GET',
        url: '/buzz/subscriptions',
        params: payload,
      });
      const data = response.data;
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const addNewBuzzSubscription = createAsyncThunk(
  `POST/${moduleName}/subscriptions`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosBuzzOne({
        method: 'POST',
        url: '/buzz/subscriptions',
        data: payload,
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const editBuzzSubscription = createAsyncThunk(
  `PUT/${moduleName}/subscriptions`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosBuzzOne({
        method: 'PUT',
        url: `/buzz/subscriptions/${payload.subscriptionId}`,
        data: payload.data,
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getAllBuzzLicenses = createAsyncThunk(
  `GET/${moduleName}/licenses`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosBuzzOne({
        method: 'GET',
        url: '/buzz/subscriptions/licenses',
        params: payload,
      });
      const data = response.data;
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const consumeBuzzLicense = createAsyncThunk(
  `POST/${moduleName}/subscriptions/licenses`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosBuzzOne({
        method: 'POST',
        url: '/buzz/subscriptions/licenses',
        data: payload,
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const consumeBuzzLicenseBulk = createAsyncThunk(
  `POST/${moduleName}/subscriptions/licenses/bulk`,
  async ({ subscriptionId, ...payload }, { rejectWithValue }) => {
    const data = new FormData();
    const KEY = 'file';
    data.append(KEY, payload.file);

    try {
      const response = await axiosBuzzOne({
        method: 'POST',
        url: `/buzz/subscriptions/${subscriptionId}/licenses/bulk`,
        data,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const revokeBuzzLicense = createAsyncThunk(
  `DELETE/${moduleName}/subscriptions/licenses`,
  async (payload, { rejectWithValue }) => {
    const { id } = payload;
    try {
      const response = await axiosBuzzOne({
        method: 'DELETE',
        url: `/buzz/subscriptions/licenses/${id}`,
        // data: data,
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getAllBuzzUsers = createAsyncThunk(
  `GET/${moduleName}/users`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosBuzzOne({
        method: 'GET',
        url: '/users',
        params: payload,
      });
      const data = response.data;
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getNotificationServiceConfig = createAsyncThunk(
  `GET/notication/config`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosBuzzNotification({
        method: 'GET',
        url: '/config',
      });
      const data = response.data;
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateNoficationConfig = createAsyncThunk(
  `PATCH/notication/config`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosBuzzNotification({
        method: 'PATCH',
        url: '/config',
        data: payload,
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const encryptText = createAsyncThunk(
  `POST/crypto/encryption`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosBuzzOne({
        method: 'POST',
        url: '/crypto/encryption',
        data: payload,
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const decryptText = createAsyncThunk(
  `POST/crypto/decryption`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosBuzzOne({
        method: 'POST',
        url: '/crypto/decryption',
        data: payload,
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const buzzSlice = createSlice({
  name: `${moduleName}`,
  initialState: {
    loading: false,
    subscriptionProducts: [],
    subscriptionPlans: [],
    // Option lists served by buzzOne (`buzz/catalog/plan.catalog.ts`); `null` until loaded.
    planOptions: null,
    planLicenseTypes: [],
    subscriptions: [],
    licenses: [],
    users: [],
    notificationConfig: {},
  },
  reducers: {},
  extraReducers: {
    [getAllBuzzSubscriptionProducts.fulfilled]: (state, action) => {
      state.loading = false;
      state.subscriptionProducts = action.payload.products;
    },
    [getAllBuzzSubscriptionPlans.fulfilled]: (state, action) => {
      state.loading = false;
      state.subscriptionPlans = action.payload.plans;
    },
    [getBuzzSubscriptionPlanOptions.fulfilled]: (state, action) => {
      state.planOptions = action.payload;
    },
    [getBuzzPlanLicenseTypes.pending]: (state) => {
      state.planLicenseTypes = [];
    },
    [getBuzzPlanLicenseTypes.fulfilled]: (state, action) => {
      state.planLicenseTypes = action.payload.licenseTypes;
    },
    [getAllBuzzSubscriptions.fulfilled]: (state, action) => {
      state.loading = false;
      state.subscriptions = action.payload.subscriptions;
    },
    [getAllBuzzLicenses.fulfilled]: (state, action) => {
      state.loading = false;
      state.licenses = action.payload.licenses;
    },
    [getAllBuzzUsers.fulfilled]: (state, action) => {
      state.loading = false;
      state.users = action.payload.users;
    },
    [getNotificationServiceConfig.fulfilled]: (state, action) => {
      state.notificationConfig = action.payload;
    },
  },
});

export default buzzSlice.reducer;
